<template>
  <div class="home-bottom-wrap">
    <div class="bottom-btn-box" @click="workClick">
      <i class="el-icon-s-platform"></i>
      <div>工作台</div>
    </div>
    <div class="bottom-btn-box" @click="personClick">
      <i class="el-icon-s-custom"></i>
      <div>个人中心</div>
    </div>

    <el-dialog title="个人中心" :visible.sync="dialogVisible" width="70%">
      <div v-if="wxUrl" style="text-align:center" class="mb-10">
        <img style="width: 100px;max-height:100px;" :src="wxUrl" alt="">
      </div>
      <div class="mb-10">昵称：{{wxName}}</div>
      <div>账号：{{username}}</div>
      <span slot="footer" class="dialog-footer dialog-footer-default footer-center">
        <el-button type="primary" @click="handleLoginOut">退出登录</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      userId: '',
      username: '',
      wxName: '',
      wxUrl: ''
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(sessionStorage.getItem('userInfo'));
    },
  },
  methods: {
    workClick() {
      // this.$router.push('/home');
      let url = '/home';
      window.location.assign(url);
    },
    personClick() {
      this.dialogVisible = true;
      this.wxName = sessionStorage.getItem('wxName') || '';
      this.wxUrl = sessionStorage.getItem('wxUrl') || '';
      this.userId = this.userInfo.userId;
      this.username = this.userInfo.username;
    },
    handleLoginOut() {
      let params = {
        id: this.userId
      }
      this.$http.post(this.$API.user_updateOpenIdEnpty, params).then(res => {
        if (res.success) {
          sessionStorage.removeItem('userInfo');
          sessionStorage.removeItem('token');
          this.$router.push('/login');
        } else {
          this.$message.error(res.msg);
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bottom-wrap {
  width: 100%;
  background-color: #fff;
  height: 60px;
  display: flex;
  align-items: center;
  // justify-content: center;
  justify-content: space-evenly;
  .bottom-btn-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 10px;
    font-size: 1.2rem;
    i {
      color: #2f70ff;
      margin-bottom: 5px;
      font-size: 2.2rem;
    }
  }
}
</style>

<style lang="scss">
.el-dialog__footer {
  .dialog-footer-default {
    .el-button--primary {
      background-color: #2f70ff !important;
      border-color: #2f70ff;
    }
    &.footer-center {
      text-align: center;
      width: 100%;
      display: inline-block;
    }
  }
}
</style>